const ToCamelCase = (string) => {
  return string.split(" ").map((word, i) => i === 0 ? word.toLowerCase() : word.slice(0, 1).toUpperCase() + word.substring(1)).join('');
};

export default ToCamelCase;
